'use client';

import DOMPurify from 'isomorphic-dompurify';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const isProduction =
  process.env.NEXT_PUBLIC_MAIN_URL === 'https://www.zhaket.com' ||
  process.env.NEXT_PUBLIC_MAIN_URL === 'https://stage.zhaket.com';

export default function LayoutMeta() {
  const disabledConsent = process.env.NEXT_PUBLIC_DISABLE_COOKIE_PERMISSION === 'true';

  const gtmScript = DOMPurify.sanitize(`
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied',
      'wait_for_update': 500
    });
  `);

  const goftinoWidgetScript = DOMPurify.sanitize(`
    !function(){
      var i="Srz4gN",a=window,d=document;
      function g(){
        var g=d.createElement("script"),
            s="https://www.goftino.com/widget/"+i,
            l=localStorage.getItem("goftino_"+i);
        g.async=!0;
        g.src=l?s+"?o="+l:s;
        d.getElementsByTagName("head")[0].appendChild(g);
      }
      "complete"===d.readyState?g():a.attachEvent?a.attachEvent("onload",g):a.addEventListener("load",g,!1);
    }();
  `);
  const trackerEndpoint = process.env.NEXT_PUBLIC_TRACKER_REAL_ENDPOINT;
  const trackerSecret = process.env.NEXT_PUBLIC_TRACKER_SECRET_KEY;

  const eventTrackerConfig =
    trackerEndpoint && trackerSecret
      ? `
(function() {
  window.EVENT_TRACKER_ENDPOINT = "${trackerEndpoint}";
  window.EVENT_TRACKER_SECRET = "${trackerSecret}";
})();
`
      : null;

  // ---------- Client-side quarterHourTimestamp (~15 min) ----------
  const [trackerVersion, setTrackerVersion] = useState(() => {
    return Math.floor(Date.now() / (15 * 60 * 1000)) * (15 * 60);
  });

  useEffect(() => {
    const interval = setInterval(
      () => {
        setTrackerVersion(Math.floor(Date.now() / (15 * 60 * 1000)) * (15 * 60));
      },
      15 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {!disabledConsent && (
        <Script
          id='gtm-dataLayer-setup'
          strategy='beforeInteractive'
          dangerouslySetInnerHTML={{ __html: gtmScript }}
        />
      )}
      {!isProduction && <meta name='robots' content='noindex, nofollow' />}
      <Script
        id='goftino-widget'
        strategy='lazyOnload'
        dangerouslySetInnerHTML={{ __html: goftinoWidgetScript }}
      />

      {eventTrackerConfig && (
        <Script
          id='event-tracker-config'
          strategy='beforeInteractive'
          dangerouslySetInnerHTML={{ __html: eventTrackerConfig }}
        />
      )}
      <Script
        src={`https://ircdn.zhaket.com/public/static-media/tracker.min.js?v=${trackerVersion}`}
        strategy='afterInteractive'
      />
    </>
  );
}
